import React from 'react'
import PropTypes from 'prop-types'

import { CarouselAdEmptyIcon } from 'images'
import { useTranslation } from 'react-i18next'
import Button from 'components/Shared/Button'

const EmptyComponent = (props) => {
  const { addCard } = props
  const { t } = useTranslation()

  return (
    <div className="carousel-ad-empty">
      <CarouselAdEmptyIcon />

      <div className="mt-3 mb-3">
        <div>{t('Recommendations.campaign.setup.carouselAd.noCards.title')}</div>
        <p className="description">{t('Recommendations.campaign.setup.carouselAd.noCards.description')}</p>
        <p className="description">{t('Recommendations.campaign.setup.carouselAd.noCards.minmax')}</p>
      </div>

      <Button text={t('Recommendations.campaign.setup.carouselAd.addCard')} type="button" onClick={() => addCard(3)} />
    </div>
  )
}

export default EmptyComponent

EmptyComponent.propTypes = {
  addCard: PropTypes.func.isRequired,
}